<div class="dialog-container" [@openState]="state">
  <div class="dialog">
    <div class="heading">
      <h2>{{ title }}</h2>
      <t-icon name="close" class="close" (click)="confirm(false)" title="Fermer"></t-icon>
    </div>
    <div class="content">
      <div class="message">
        {{ message }}
      </div>
      <div class="buttons">
        <button class="btn btn-small" [ngClass]="confirm_button_class" (click)="confirm(true)">
          <t-icon name="check"></t-icon>
          <span class="text">{{ confirm_button_text }}</span>
        </button>

        <button class="btn btn-small btn-gray" (click)="confirm(false)">
          <t-icon name="close"></t-icon>
          <span class="text">Annuler</span>
        </button>
      </div>
    </div>
  </div>
</div>